import {
    iconRequest,
    iconClient,
    iconCalculator,
    iconReportsDefault,
    iconReports,
    iconSearch,
    iconParameters,
} from '../defaultValues';

const data = {
    role_ec2f8a43cebf47aa8ef8d43483001195: [
        {
            id: 'gogo',
            icon: iconRequest,
            label: 'Solicitudes',
            to: '/app/credits',
        },
        {
            id: 'searcRequest',
            icon: iconSearch,
            label: 'Buscar Solicitud',
            to: '/app/reports/searchRequest',
        },
        {
            id: 'secondmenu',
            icon: iconClient,
            label: 'Clientes',
            to: '/app/clients',
        },
        {
            id: 'cartera',
            icon: iconReportsDefault,
            label: 'Cartera',
            to: '/app/calculator',
            subs: [
                {
                    id: 'mora-collection',
                    icon: iconReportsDefault,
                    label: 'Mora',
                    to: '/app/collection/lista',
                },
                {
                    id: 'par1&par30-collection',
                    icon: iconReportsDefault,
                    label: 'Par1 & Par30',
                    to: '/app/collection/per1AndPer30',
                },
                {
                    id: 'par1&par30C-collection',
                    icon: iconReportsDefault,
                    label: 'Comparativo Cartera',
                    to: '/app/collection/per1AndPer30Comparative',
                },
                {
                    id: 'aprobadas-desembolsadas',
                    icon: iconReportsDefault,
                    label: 'Aprobadas vs Desembolsadas',
                    to: '/app/collection/ComparatibeApproveDisbursed',
                },
                {
                    id: 'tuberia',
                    icon: iconReportsDefault,
                    label: 'Tuberia',
                    to: '/app/collection/Pipeline',
                },
            ],
        },
        {
            id: 'blankpage',
            icon: iconReports,
            label: 'Reportes',
            to: '/app/blank-page',
            subs: [
                {
                    icon: iconReportsDefault,
                    label: 'Generales',
                    to: '/app/reports/reportsDisbursement',
                },
                {
                    icon: iconReportsDefault,
                    label: 'Comparativo 12 meses',
                    to: '/app/reports/comparative12Months',
                },
                {
                    icon: iconReportsDefault,
                    label: 'Desempeño Equipos',
                    to: '/app/reports/teamPerformance',
                },
                {
                    icon: iconReportsDefault,
                    label: 'Comparativo Productividad',
                    to: '/app/reports/productivityComparative',
                },
                {
                    icon: iconReportsDefault,
                    label: 'FNG',
                    to: '/app/reports/annexes',
                    subs: [
                        {
                            id: 'fng-reports',
                            icon: iconReportsDefault,
                            label: 'Reporte',
                            to: '/app/reports/annexes',
                        },
                        {
                            id: 'fng-cir',
                            icon: iconReportsDefault,
                            label: 'CIR',
                            to: '/app/reports/reportCir',
                        },
                    ],
                },
                {
                    icon: iconReportsDefault,
                    label: 'Cierre Mes',
                    to: '/app/reports/reportMonthEnd',
                },
                {
                    id: 'tiempos de respuesta',
                    icon: iconReportsDefault,
                    label: 'Tiempos de Respuesta',
                    to: '/app/reports/reportAnswerTimes',
                },
                {
                    id: 'seguimiento',
                    icon: iconReportsDefault,
                    label: 'Seguimiento',
                    to: '/app/reports/reportsRequestTracking',
                },
                {
                    icon: iconReportsDefault,
                    label: 'Garantías Comunitarias',
                    to: '/app/reports/communityGuarantees',
                },
            ],
        },
        {
            id: 'simulador-credito',
            icon: iconCalculator,
            label: 'Simulador de Crédito',
            to: '/app/calculator',
            subs: [
                {
                    icon: iconCalculator,
                    label: 'Simulador de Créditos',
                    to: '/app/calculator',
                },
                {
                    icon: iconCalculator,
                    label: 'Calculadora R&R',
                    to: '/app/reports/calculatorRefinancing',
                },
            ],
        },
        {
            id: 'parametros',
            icon: iconParameters,
            label: 'Parámetros',
            to: '/app/calculator',
            subs: [
                {
                    id: 'tuberia',
                    icon: iconReportsDefault,
                    label: 'Calculadora',
                    to: '/app/reports/calculatorParams',
                },
            ],
        },
    ],
};
export default data;
